<template>
    <div id="Vaccinations">
        <PetButtonDropDown
            :img_src="
                require('@/assets/svg/pet-card-tabs/health/vaccination-colored.svg')
            "
            :name="'Vaccinations'"
            :gray_text="'Vaccinations records'"
            :bg_color="'rgba(98, 103, 249, 0.1)'"
        >
            <div
                class="details-container"
                v-if="
                    !addingVaccination &&
                    vaccination_que.length == 0 &&
                    loading == false
                "
            >
                <div class="no-details-box">
                    <div
                        class="pic-upload"
                        :style="{
                            'background-image':
                                'url(' +
                                require('@/assets/svg/pet-card-icon/dog-bowl.svg') +
                                ')',
                        }"
                    ></div>
                    <p class="gallery-text">
                        {{ pet_data.name }} does not have any vaccinations.
                    </p>
                </div>
            </div>

            <div class="menu-group">
                <XyzTransitionGroup
                    xyz="fade left-100%"
                    v-if="vaccination_que.length > 0 && !loading"
                >
                    <div
                        v-for="(mu, idx) in vaccination_que"
                        :key="idx"
                        class="menu-box"
                    >
                        <div
                            :class="{
                                'menu-item-bar': true,
                                'menu-rounded-top': idx === 0,
                                'menu-rounded-bottom': idx === vaccination_que.length - 1
                                }"
                        >
                            <span class="icon-text">
                                {{ mu }}
                            </span>
                        </div>
                    </div>

                    <div class="menu-box" key="nav-menu">
                        <div
                            v-if="
                                load_more &&
                                all_vaccination_data &&
                                all_vaccination_data.length > 5
                            "
                            class="menu-item-bar menu-button-nav menu-rounded-bottom"
                            @click="togglePagination()"
                        >
                            Load More
                        </div>
                        <div
                            v-else-if="
                                all_vaccination_data &&
                                all_vaccination_data.length > 5
                            "
                            class="menu-item-bar menu-button-nav menu-rounded-bottom"
                            @click="togglePagination()"
                        >
                            Show Less
                        </div>
                    </div>
                </XyzTransitionGroup>
            </div>
        </PetButtonDropDown>
    </div>
</template>

<script>
import { mapState } from "vuex";
import PetButtonDropDown from "@/petprofile/components/pet/tabs/PetButtonDropDown";

export default {
    name: "Vaccinations",
    components: {
        PetButtonDropDown,
    },
    data() {
        return {
            loading: false,
            addingVaccination: false,
            vaccination_que: [],
            load_more: true,
            all_vaccination_data: [],
            // pet_data:{vaccinations:[]}
        };
    },
    methods: {
        togglePagination() {
            if (this.vaccination_que.length > 5) {
                this.vaccination_que = this.all_vaccination_data.slice(0, 5);
            } else {
                this.vaccination_que = this.all_vaccination_data;
            }
            this.load_more = !this.load_more;
        },
        async getPetData() {
            this.loading = true;
            this.all_vaccination_data = this.pet_data.vaccinations ? this.pet_data.vaccinations.map((a) => {
                return a.vaccine;
            }) : [];
            // console.log(this.all_vaccination_data);
            if (this.all_vaccination_data.length <= 5) {
                this.load_more = false;
                this.vaccination_que = this.all_vaccination_data;
            } else {
                this.load_more = true;
                this.vaccination_que = this.all_vaccination_data.slice(0, 5);
            }
            this.loading = false;
            return this.pet_data;
        },
    },
    computed: {
        ...mapState(["userID", "pet_data"]),
    },
    created() {
        this.getPetData();
    },
};
</script>
<style scoped>
#Vaccinations {
    margin: auto;
    padding-bottom: 1rem;
}
.menu-group {
    margin: 0 auto;
}
.menu-button-nav {
    display: flex !important;
    color: var(--primary);
    justify-content: center !important;
    align-items: center !important;
    text-align: center !important;
    margin-top: 1rem;
}
.menu-rounded-top {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
}
.menu-rounded-bottom {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
}
.menu-item-bar {
    max-height: 3.5rem;
    background-color: #fff;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    transition: 1s;
    margin: 1px auto;
    padding: 8px 18px;
    background: #fff;
    border: 1px solid rgba(255, 255, 255, 0.18);
}
/* .menu-item-bar:hover{
  transform: translateY(-10px);
} */
.setting-icon {
    width: 1.5rem;
    height: 1.5rem;
    cursor: pointer;
    margin: 0 0.5rem;
}
.icon-text {
    display: flex;
    font-weight: 400;
    font-size: 16px;
    text-transform: capitalize;
    color: #00133d;
    line-height: 24px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.no-details-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.no-details-box img {
    width: 8rem;
    transition: 1s;
    margin: 2rem auto;
}
.pic-upload {
    position: relative;
    width: 12rem;
    height: 12rem;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 70%;
}

.gallery-text {
    font-weight: bold;
    color: #adb6e1;
    text-align: center;
    font-size: 1.3rem;
}

.pic-upload:hover img {
    transform: translateY(-6px);
}

body[data-theme="dark"] #Vaccinations {
    background-color: #222;
    color: var(--text-dark);
    border-color: var(--text-dark);
}
body[data-theme="dark"] .menu-item-bar {
    background-color: #555;
}
/*mobile base */
@media only screen and (max-width: 600px) {
    .menu-group {
        text-align: center;
        /* min-height: 90vh; */
    }
    .menu-item-bar {
        margin: 1px auto;
    }
    .setting-icon {
        width: 1rem;
        height: 1rem;
    }
}
@media only screen and (max-width: 400px) {
}
</style>
